import { TableColumn, TableStyles } from 'react-data-table-component';
import { WaBranchOption } from 'src/api/wa/store/WaFilterStore';

export interface DisasterTableRow {
  item1: WaBranchOption | null;
  item2: WaBranchOption | null;
  item3: WaBranchOption | null;
  item4: WaBranchOption | null;
  item5: WaBranchOption | null;
  item6: WaBranchOption | null;
  item7: WaBranchOption | null;
  item8: WaBranchOption | null;
}

export const transformToDisasterRows = (branches: WaBranchOption[]): DisasterTableRow[] => {
  const rows: DisasterTableRow[] = [];
  for (let i = 0; i < branches.length; i += 8) {
    rows.push({
      item1: branches[i] || null,
      item2: branches[i + 1] || null,
      item3: branches[i + 2] || null,
      item4: branches[i + 3] || null,
      item5: branches[i + 4] || null,
      item6: branches[i + 5] || null,
      item7: branches[i + 6] || null,
      item8: branches[i + 7] || null,
    });
  }
  return rows;
};

export const disasterCustomStyles: TableStyles = {
  tableWrapper: {
    style: {
      display: 'block',
    },
  },
  table: {
    style: {
      backgroundColor: 'transparent',
      width: '100%',
    },
  },
  rows: {
    style: {
      minHeight: '2rem',
    },
  },
  cells: {
    style: {
      padding: '0px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};

const createColumn = (
  itemKey: keyof DisasterTableRow,
  type: 'code' | 'name',
  getHighlightStyle: (code?: string) => React.CSSProperties
): TableColumn<DisasterTableRow> => {
  const isCode = type === 'code';

  return {
    name: `${type} ${itemKey}`,
    cell: (row) => {
      const data = row[itemKey];
      const content = data ? data[type] : '';
      const baseClass = isCode
        ? 'font-mono text-sm border-gray-300'
        : 'font-semibold whitespace-nowrap px-4 border-r border-gray-300';

      return (
        <div
          className={`flex size-full items-center justify-center ${baseClass}`}
          style={getHighlightStyle(data?.code)}
        >
          {content}
        </div>
      );
    },
    width: isCode ? '4rem' : '8.5rem',
  };
};

export const disasterColumns = (
  highlightedCodes: string[] = []
): TableColumn<DisasterTableRow>[] => {
  const getHighlightStyle = (code?: string): React.CSSProperties => {
    if (!code) return {};
    const shouldHighlight = highlightedCodes.includes(code);
    if (shouldHighlight) {
      return { backgroundColor: '#fef08a', fontWeight: 'bold' };
    }
    return {};
  };

  return [
    createColumn('item1', 'code', getHighlightStyle),
    createColumn('item1', 'name', getHighlightStyle),
    createColumn('item2', 'code', getHighlightStyle),
    createColumn('item2', 'name', getHighlightStyle),
    createColumn('item3', 'code', getHighlightStyle),
    createColumn('item3', 'name', getHighlightStyle),
    createColumn('item4', 'code', getHighlightStyle),
    createColumn('item4', 'name', getHighlightStyle),
    createColumn('item5', 'code', getHighlightStyle),
    createColumn('item5', 'name', getHighlightStyle),
    createColumn('item6', 'code', getHighlightStyle),
    createColumn('item6', 'name', getHighlightStyle),
    createColumn('item7', 'code', getHighlightStyle),
    createColumn('item7', 'name', getHighlightStyle),
    createColumn('item8', 'code', getHighlightStyle),
    createColumn('item8', 'name', getHighlightStyle),
  ];
};
